import React, { useCallback } from 'react';
import { detailedComputeCountByTypeData } from "service/service";
import ComputeHierarchyBase, { FetchServiceParams } from './ComputeHierarchyBase';

const ComputeCountDetails = () => {
    const serviceFunc = useCallback((params: FetchServiceParams) => {
        return detailedComputeCountByTypeData({
            startDate: params.startDate,
            endDate: params.endDate,
            env: params.env,
            sector: params.sector,
            location: params.location,
            computeType: params.computeType,
            page: params.page,
            pageSize: params.pageSize,
            filters: params.filters,
            selectedDateInString: params.apiDateRangeKey
        });
    }, []);

    return (
        <ComputeHierarchyBase
            serviceFunc={serviceFunc}
            pageTitle="Compute Count Details"
            tableTitlePrefix="Total Compute Count"
            columnLabel="Compute Count"
            isCurrency={false}
            preserveFilterKey="compute_count_filters"
            detailPath="/databricksADB/Count/detail_table"
            tableType="compute-count-details"
        />
    );
};

export default ComputeCountDetails;